import localforage from 'localforage'

// Using the legacy name so we can stay in sync with the original app
localforage.config({
  name: 'rpp',
})

export const sessionDataHandler = localforage
